/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Grid } from '@mui/material'
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import HouseIcon from '@mui/icons-material/House';
import { FaFlagCheckered, FaHourglassHalf } from "react-icons/fa";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { AiOutlineWechat } from "react-icons/ai";
import { MdEmail, MdOutlineMarkEmailRead } from "react-icons/md";
import "./HomeBackEnd.css";
import BAHomeIssue from './BAservice/BAHomeIssue';
import BAHomeProductService from './BAservice/BAHomeProductService';
import BAHomeSuggestion from './BAservice/BAHomeSuggestion';
import BAInprogress from './BAservice/BAInprogress';
import BAUpdatePlan from './BAservice/BAUpdatePlan';
import BAResolved from './BAservice/BAResolved';
import BAClosed from './BAservice/BAClosed';
import ApproverHomePart from './Approver/ApproverHomePart';
import ApproverHomeDepart from './Approver/ApproverHomeDepart';
import moment from 'moment';
import { AxiosGet, ResultAPI } from 'service/CommonFunction/TS_function';
import { useNavigate } from 'react-router-dom';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';


const HomeBackEnd = () => {

    const { BlockUI, UnBlockUI } = FnBlock_UI();

    const [arrCardBAservice, setarrCardBAservice] = useState([] as any)
    const [arrCardApproverPart, setarrCardApproverPart] = useState([] as any)
    const [arrCardApproverDepart, setarrCardApproverDepart] = useState([] as any)
    const [sRoleUser, setsRoleUser] = useState(null)    //ba, part, depart
    const navigate = useNavigate();

    const [CardActionBA, setCardActionBA] = useState(1)
    const [CardActionApproverPart, setCardActionApproverPart] = useState(0)
    const [CardActionApproverDepart, setCardActionApproverDepart] = useState(0)

    const [Option, setOption] = useState({
        lstVOCType: [],
        lstVOCJobType: [],
        lstVOCFormType: [],
        lstBA: [],
        lstBASuggestion: [],
        lstProductServiceType: [],
    })

    useEffect(() => {
        GetAllOption();
        GetUserData();
    }, [])

    useEffect(() => {
        GetDashboard();
    }, [CardActionBA, CardActionApproverPart, CardActionApproverDepart])

    const GetDashboard = async () => {
        let nYear = moment().year();
        BlockUI()
        await AxiosGet(`VOC/GetVOCDashboard`, { "nYear": nYear, "sLanguage": "th" }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, () => {
                setarrCardBAservice(res.result?.data)
                setarrCardApproverPart(res.result?.data)
                setarrCardApproverDepart(res.result?.data)
            })
        });
    }

    const GetUserData = async () => {
        await AxiosGet("User/GetUserData", { "sLanguage": "th" }, (res) => {
            ResultAPI(res, null, () => {
                setsRoleUser(res.result.sPISRole === "DM" ? "part" : res.result.sPISRole === "VP" ? "depart" : "ba")
                if (res.result.sPISRole === "DM") {
                    setCardActionApproverPart(9)
                }
                else if (res.result.sPISRole === "VP") {
                    // setCardActionApproverPart(9)
                    setCardActionApproverDepart(12)
                }
            })
        })

        // await GetDashboard();

    };

    const GetAllOption = async () => {

        //
        let oOptionVOC = {
            lstVOCType: [],
            lstVOCJobType: [],
            lstVOCFormType: [],
            lstBA: [],
            lstBASuggestion: [],
            lstProductServiceType: [],
        };

        //#region  New
        await AxiosGet(`BAService/GetBAType`, { "sLanguage": "th" }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstVOCType: res.result?.data || [] }
            })
        });

        await AxiosGet(`MasterData/GetVOCFormType`, { "sLanguage": "th" }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstVOCFormType: res.result?.data || [] }
            })
        });

        await AxiosGet(`MasterData/GetVOCJobType`, { "IsSuggest": false }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstVOCJobType: res.result?.data || [] }
            })
        });

        await AxiosGet(`BAService/GetBASearch`, { "IsSuggestion": false }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstBA: res.result?.data || [] }
            })
        });

        await AxiosGet(`BAService/GetBASearch`, { "IsSuggestion": true }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstBASuggestion: res.result?.data }
            })
        });

        await AxiosGet(`VOC/GetOptionPrdService`, { "sLanguage": "th" }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstProductServiceType: res.result?.data || [] }
            })
        });

        //#endregion

        await onSetOption(oOptionVOC);
    }

    const onSetOption = async (paramOption) => {
        setOption(paramOption)
        UnBlockUI();

    }

    //BA service
    const JsxBoxCard = (sType, dataItem, nCard) => {

        let JsxElement = null;

        switch (nCard) {
            case 1:
                JsxElement =
                    <div className="containerCard-ba" onClick={() => { onHandleChangeBox(sType, dataItem.nID) }}>
                        <div className="card1" style={{ background: CardActionBA === 1 ? "#ffdbe6" : "#ffffff" }}>
                            <div className="borderBoxEmpty"></div>
                            <div className="IconBoxVoc"><MdEmail style={{ color: '#d9001b', marginTop: '3px' }} /></div>
                            <div className="nameBoxVoc">{dataItem.sTab ?? ""}</div>
                            <div className="numVoc">{dataItem.nVOC ?? ""}</div>
                        </div>
                    </div>
                break;
            case 2:
                JsxElement =
                    <div className="containerCard-ba" onClick={() => { onHandleChangeBox(sType, dataItem.nID) }}>
                        <div className="card2" style={{ background: CardActionBA === 2 ? "#cbe2ff" : "#ffffff" }}>
                            <div className="borderBoxEmpty"></div>
                            <div className="IconBoxVoc"><MdEmail style={{ color: '#016efe', marginTop: '3px' }} /></div>
                            <div className="nameBoxVoc">{dataItem.sTab ?? ""}</div>
                            <div className="numVoc">{dataItem.nVOC ?? ""}</div>
                        </div>
                    </div>
                break;
            case 3:
                JsxElement =
                    <>
                        <div className="containerCard-ba" onClick={() => { onHandleChangeBox(sType, dataItem.nID) }}>
                            <div className="card3" style={{ background: CardActionBA === 3 ? "#ffe5d8" : "#ffffff" }}>
                                <div className="borderBoxEmpty"></div>
                                <div className="IconBoxVoc"><MdEmail style={{ color: '#ff7c35', marginTop: '3px' }} /></div>
                                <div className="nameBoxVoc">{dataItem.sTab ?? ""}</div>
                                <div className="numVoc">{dataItem.nVOC ?? ""}</div>
                                <div className='now-year'>ประจำปี {moment().add(543, 'year').format("YYYY")}</div>
                            </div>
                        </div>
                    </>
                break;
            case 4:
                JsxElement =
                    <div className="containerCard-ba" onClick={() => { navigate("/Backend/LiveChat") }}>
                        <div className="card5" style={{ background: CardActionBA === 4 ? "#cdf4e8" : "#ffffff" }}>
                            <div className="borderBoxEmpty"></div>
                            <div className="IconBoxVoc"><AiOutlineWechat style={{ color: '#11c990', marginTop: '3px' }} /></div>
                            <div className="nameBoxVoc">{dataItem.sTab ?? ""}</div>
                            <div className="numVoc">{dataItem.nVOC ?? ""}</div>
                        </div>
                    </div>
                break;
            case 5:
                JsxElement =
                    <div className="containerCard-ba" onClick={() => { onHandleChangeBox(sType, dataItem.nID) }}>
                        <div className="card3" style={{ background: CardActionBA === 5 || CardActionApproverPart === 9 || CardActionApproverDepart === 12 ? "#ffe5d8" : "#ffffff" }}>
                            <div className="borderBoxEmpty"></div>
                            <div className="IconBoxVoc"><FaHourglassHalf style={{ color: '#ff7c35', marginTop: '3px' }} /></div>
                            <div className="nameBoxVoc">{dataItem.sTab ?? ""}</div>
                            <div className="numVoc">{dataItem.nVOC ?? ""}</div>
                        </div>
                    </div>
                break;
            case 6:
                JsxElement =
                    <div className="containerCard-ba" onClick={() => { onHandleChangeBox(sType, dataItem.nID) }}>
                        <div className="card3" style={{ background: CardActionBA === 6 || CardActionApproverDepart === 13 || CardActionApproverPart === 16 ? "#ffe5d8" : "#ffffff" }}>
                            <div className="borderBoxEmpty"></div>
                            <div className="IconBoxVoc"><FaFlagCheckered style={{ color: '#ff7c35', marginTop: '3px' }} /></div>
                            <div className="nameBoxVoc">{dataItem.sTab ?? ""}</div>
                            <div className="numVoc">{dataItem.nVOC ?? ""}</div>
                        </div>
                    </div>
                break;
            case 7:
                JsxElement =
                    <div className="containerCard-ba" onClick={() => { onHandleChangeBox(sType, dataItem.nID) }}>
                        <div className="card5" style={{ background: CardActionBA === 7 || CardActionApproverPart === 11 || CardActionApproverDepart === 14 ? "#cdf4e8" : "#ffffff" }}>
                            <div className="borderBoxEmpty"></div>
                            <div className="IconBoxVoc"><BsFillCheckCircleFill style={{ color: '#11c990', marginTop: '3px' }} /></div>
                            <div className="nameBoxVoc">{dataItem.sTab ?? ""}</div>
                            <div className="numVoc">{dataItem.nVOC ?? ""}</div>
                        </div>
                    </div>
                break;
            case 8:
                JsxElement =
                    <div className="containerCard-ba" onClick={() => { onHandleChangeBox(sType, dataItem.nID) }}>
                        <div className="card4" style={{ background: CardActionBA === 8 ? "linear-gradient(90deg, rgba(0,236,145,1) 0%, rgba(0,163,244,1) 100%)" : "#ffffff" }}>
                            <div className="borderBoxEmpty" style={{ background: 'linear-gradient(90deg, rgba(0,236,145,1) 0%, rgba(0,163,244,1) 100%)' }}></div>
                            <div className="IconBoxVoc"><MdOutlineMarkEmailRead style={{ color: '#ffffff', marginTop: '3px' }} /></div>
                            <div className="nameBoxVoc">{dataItem.sTab ?? ""}</div>
                            <div className="numVoc">{dataItem.nVOC ?? ""}</div>
                        </div>
                    </div>
                break;
            case 9:          //dup for active color
                JsxElement =
                    <div className="containerCard-ba" onClick={() => { onHandleChangeBox(sType, dataItem.nID) }}>
                        <div className="card3" style={{ background: CardActionApproverPart === 10 || CardActionApproverDepart === 15 ? "#ffe5d8" : "#ffffff" }}>
                            <div className="borderBoxEmpty"></div>
                            <div className="IconBoxVoc"><FaHourglassHalf style={{ color: '#ff7c35', marginTop: '3px' }} /></div>
                            <div className="nameBoxVoc">{dataItem.sTab ?? ""}</div>
                            <div className="numVoc">{dataItem.nVOC ?? ""}</div>
                        </div>
                    </div>
                break;
            case 10:         //dup for active color
                JsxElement =
                    <div className="containerCard-ba" onClick={() => { onHandleChangeBox(sType, dataItem.nID) }}>
                        <div className="card3" style={{ background: CardActionBA === 5 || CardActionApproverPart === 9 || CardActionApproverDepart === 12 ? "#ffe5d8" : "#ffffff" }}>
                            <div className="borderBoxEmpty"></div>
                            <div className="IconBoxVoc"><FaHourglassHalf style={{ color: '#ff7c35', marginTop: '3px' }} /></div>
                            <div className="nameBoxVoc">{dataItem.sTab ?? ""}</div>
                            <div className="numVoc">{dataItem.nVOC ?? ""}</div>
                        </div>
                    </div>
                break;
                case 11:        //dup for active color
                    JsxElement =
                        <div className="containerCard-ba" onClick={() => { onHandleChangeBox(sType, dataItem.nID) }}>
                            <div className="card3" style={{ background: CardActionApproverDepart === 17 ? "#ffe5d8" : "#ffffff" }}>
                                <div className="borderBoxEmpty"></div>
                                <div className="IconBoxVoc"><FaHourglassHalf style={{ color: '#ff7c35', marginTop: '3px' }} /></div>
                                <div className="nameBoxVoc">{dataItem.sTab ?? ""}</div>
                                <div className="numVoc">{dataItem.nVOC ?? ""}</div>
                            </div>
                        </div>
                    break;
            default:
                break;
        }

        return JsxElement;
    }

    const onHandleChangeBox = (sType, nCard) => {
        if (sType === "ba") {
            setCardActionBA(nCard)
        }
        else if (sType === "approvepart") {
            setCardActionApproverPart(nCard)
        }
        else if (sType === "approvedepart") {
            setCardActionApproverDepart(nCard)

        }
    }

    return (
        <>
            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                <Grid item xs={12}>
                    <InnerHeadRoutes
                        iconMUI={<HouseIcon style={{ fontSize: '1.5em' }} />}
                        labal_Head="หน้าแรก"
                    />
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >

                        {
                            sRoleUser === "ba"
                                ?
                                <>


                                    <Grid item xs={12}>
                                        <Grid container spacing={2} direction="row" justifyContent="space-around" alignItems="center" >
                                            {arrCardBAservice != null && arrCardBAservice.length === 0 ? null :
                                                arrCardBAservice.map((dataItem, index) => {
                                                    return (
                                                        <Grid key={index} item xs={6} sm={6} md={3}>
                                                            {JsxBoxCard("ba", dataItem, dataItem.nTyprCard)}
                                                        </Grid>
                                                    )
                                                })}
                                        </Grid>
                                    </Grid>

                                    {CardActionBA === 1 ? <Grid item xs={12}><BAHomeIssue GetDashboard={GetDashboard} CardAction={CardActionBA} Option={Option} /></Grid> : null}
                                    {CardActionBA === 2 ? <Grid item xs={12}><BAHomeProductService GetDashboard={GetDashboard} CardAction={CardActionBA} Option={Option} /></Grid> : null}
                                    {CardActionBA === 3 ? <Grid item xs={12}><BAHomeSuggestion GetDashboard={GetDashboard}  CardAction={CardActionBA} Option={Option} /></Grid> : null}
                                    {CardActionBA === 5 ? <Grid item xs={12}><BAInprogress GetDashboard={GetDashboard}  CardAction={CardActionBA} Option={Option} /></Grid> : null}
                                    {CardActionBA === 6 ? <Grid item xs={12}><BAUpdatePlan GetDashboard={GetDashboard}  CardAction={CardActionBA} Option={Option} /></Grid> : null}
                                    {CardActionBA === 7 ? <Grid item xs={12}><BAResolved GetDashboard={GetDashboard}  CardAction={CardActionBA} Option={Option} /></Grid> : null}
                                    {CardActionBA === 8 ? <Grid item xs={12}><BAClosed GetDashboard={GetDashboard}  CardAction={CardActionBA} Option={Option} /></Grid> : null}


                                </>
                                : null
                        }
                        {
                            sRoleUser === "part"
                                ?

                                <>

                                    <Grid item xs={12}>
                                        <Grid container spacing={2} direction="row" justifyContent="space-around" alignItems="center" >
                                            {arrCardApproverPart != null && arrCardApproverPart.length === 0 ? null :
                                                arrCardApproverPart.map((dataItem, index) => {
                                                    return (
                                                        <Grid key={index} item xs={12} sm={6} md={3}>
                                                            {JsxBoxCard("approvepart", dataItem, dataItem.nTyprCard)}
                                                        </Grid>
                                                    )
                                                })}
                                        </Grid>
                                    </Grid>

                                    {CardActionApproverPart === 9 ? <Grid item xs={12}><ApproverHomePart GetDashboard={GetDashboard}  CardAction={CardActionApproverPart} Option={Option} /></Grid> : null}
                                    {CardActionApproverPart === 10 ? <Grid item xs={12}><BAInprogress GetDashboard={GetDashboard}  CardAction={CardActionApproverPart} Option={Option} /></Grid> : null}
                                    {CardActionApproverPart === 16 ? <Grid item xs={12}><BAUpdatePlan GetDashboard={GetDashboard}  CardAction={CardActionApproverPart} Option={Option} /></Grid> : null}
                                    {CardActionApproverPart === 11 ? <Grid item xs={12}><BAResolved GetDashboard={GetDashboard}  CardAction={CardActionApproverPart} Option={Option} /></Grid> : null}

                                </>
                                : null
                        }
                        {
                            sRoleUser === "depart"
                                ?
                                <>
                                    <Grid item xs={12}>
                                        <Grid container spacing={2} direction="row" alignItems="center" >
                                            {arrCardApproverDepart != null && arrCardApproverDepart.length === 0 ? null :
                                                arrCardApproverDepart.map((dataItem, index) => {
                                                    return (
                                                        <Grid key={index} item xs={12} sm={6} md={4}>
                                                            {JsxBoxCard("approvedepart", dataItem, dataItem.nTyprCard)}
                                                        </Grid>
                                                    )
                                                })}
                                        </Grid>
                                    </Grid>

                                    {CardActionApproverDepart === 12 ? <Grid item xs={12}><ApproverHomeDepart GetDashboard={GetDashboard}  CardAction={CardActionApproverDepart} Option={Option} /></Grid> : null}
                                    {CardActionApproverDepart === 17 ? <Grid item xs={12}><ApproverHomePart GetDashboard={GetDashboard}  CardAction={CardActionApproverDepart} Option={Option} /></Grid> : null}
                                    {CardActionApproverDepart === 15 ? <Grid item xs={12}><BAInprogress GetDashboard={GetDashboard}  CardAction={CardActionApproverDepart} Option={Option} /></Grid> : null}
                                    {CardActionApproverDepart === 13 ? <Grid item xs={12}><BAUpdatePlan GetDashboard={GetDashboard}  CardAction={CardActionApproverDepart} Option={Option} /></Grid> : null}
                                    {CardActionApproverDepart === 14 ? <Grid item xs={12}><BAResolved GetDashboard={GetDashboard}  CardAction={CardActionApproverDepart} Option={Option} /></Grid> : null}
                                </>
                                : null
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>

    )
}

export default HomeBackEnd